export const user_type = [
    { "user_type_id": "2", "name": "Surgeon (15+ years experience)" },
    { "user_type_id": "3", "name": "Surgeon (Less than 15 years experience)" },
    { "user_type_id": "4", "name": "PG Student" },
    { "user_type_id": "5", "name": "Company user- Medical Device manufacturer" },
    { "user_type_id": "6", "name": "Company user- Pharma" },
    { "user_type_id": "7", "name": "Hospital Staff" },
    { "user_type_id": "8", "name": "Medical Institute" },
    { "user_type_id": "9", "name": "Others" }
  ]